import React, { useState } from 'react';

const Upload = () => {
  const [files, setFiles] = useState({
    invoice: null,
    deliveryChallan: null,
    bill: null,
    other: null,
  });

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [type]: file,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle file uploads here
    console.log('Files to upload:', files);
  };

  return (
    <div className='max-w-3xl mx-auto poppins-bold p-4'>
      <h2 className='text-xl font-semibold mb-4'>Upload Documents</h2>
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
          <div>
            <label className='block text-sm font-medium text-gray-700'>Invoice Upload</label>
            <input
              type='file'
              accept='application/pdf'
              onChange={(e) => handleFileChange(e, 'invoice')}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black'
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700'>Delivery Challan Upload</label>
            <input
              type='file'
              accept='application/pdf'
              onChange={(e) => handleFileChange(e, 'deliveryChallan')}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black'
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700'>Bill Upload</label>
            <input
              type='file'
              accept='application/pdf'
              onChange={(e) => handleFileChange(e, 'bill')}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black'
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700'>Other Upload</label>
            <input
              type='file'
              accept='application/pdf'
              onChange={(e) => handleFileChange(e, 'other')}
              className='mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black'
            />
          </div>
        </div>

        <button
          type='submit'
          className='mt-4 w-full py-2 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black'
        >
          Upload Files
        </button>
      </form>
    </div>
  );
};

export default Upload;
